import axios from 'axios';
import setupInterceptors from '@/services/setupInterceptors';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
var appApis = null;
if (!configuration['search']) {
  appApis = axios.create({
    baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':8050')
  });
} else {
  appApis = axios.create({
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8092')
  });
}
var beforeMiddleware = function beforeMiddleware(config) {
  // tasks.getUserInfo()
  config.headers['Authorization'] = "Bearer " + window.userInfo.accessToken;
  return config;
};
setupInterceptors(appApis);
export default {
  getBuscador: function getBuscador(valor) {
    var paramFinalTable = valor.final_table ? '&final_table=' + valor.final_table : '';
    var paramDataOperator = valor.data_operator ? '&data_operator=' + valor.data_operator : '';
    var paramZone = valor.zone ? '&zone=' + valor.zone : '';
    return appApis.get('/search-engine/search?dominio=' + valor.domain + '&object=' + valor.object_comma + '&query_by=' + valor.query_by_comma + '&q=' + valor.q + '&per_page=' + valor.per_page + '&page=' + valor.page + paramFinalTable + paramDataOperator + paramZone).then(function (response) {
      console.log(response);
      return response.data;
    });
  },
  getVectorSearch: function getVectorSearch(valor) {
    var paramFinalTable = valor.final_table ? '&final_table=' + valor.final_table : '';
    var paramDataOperator = valor.data_operator ? '&data_operator=' + valor.data_operator : '';
    var paramZone = valor.zone ? '&zone=' + valor.zone : '';
    return appApis.get('/search-engine/search-vector?dominio=' + valor.domain + '&object=' + valor.object_comma + '&query_by=' + valor.query_by_comma + '&q=' + valor.q + '&per_page=' + valor.per_page + '&page=' + valor.page + paramFinalTable + paramDataOperator + paramZone).then(function (response) {
      return response.data;
    });
  }
};